import Typograf from 'typograf';

export default new Typograf({ locale: ['ru'] });
